import React, { ReactNode } from "react";
import MaterialCssBaseline from "@mui/material/CssBaseline";
import MaterialScopedCssBaseline from "@mui/material/ScopedCssBaseline";

interface ICssBaselineProps {
    scoped: boolean;
    children?: ReactNode;
}

export function CssBaseline(props: ICssBaselineProps) {
    const { scoped, children } = props;
    const Wrapper = scoped ? MaterialScopedCssBaseline : MaterialCssBaseline;
    return <Wrapper>{children}</Wrapper>;
}
